export const SAVE_CARD_FOR_FASTER_CHECKOUT_LABEL = 'Save card for faster checkout';

export const SAVE_CARD_FOR_FASTER_CHECKOUT_TOOLTIP =
    'When you save your card, you will not need to type in your card number every time. ' +
    'Instead, you can select it from a list of saved cards. And you can delete a saved ' +
    'card at any time.';
